import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forkJoin, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ILocalidad } from '../../models/ILocalidad';
import { UsuarioService } from '../../services/usuario.service';
import {
  loadLocalidades,
  loadedLocalidadesError,
  loadedLocalidadesSuccess
} from './localidad.actions';


@Injectable()
export class LocalidadEffects {   
  constructor(private actions$: Actions, public dataService: UsuarioService) {
    this.loadLocalidades$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadLocalidades),
        switchMap(() =>
          forkJoin({
            localidades: this.dataService.getLocalidades(),
          }).pipe(
            map((response: { localidades: ILocalidad[] }) => {
              return loadedLocalidadesSuccess({ localidades: response.localidades });
            }),
            catchError((error) => of(loadedLocalidadesError({ error })))
          )
        )
      )
    );
  }

  loadLocalidades$?: unknown
}
